// Save/load a complete project as JSON.
// The JSON includes images as data URLs so the project is fully self-contained.

export const PROJECT_VERSION = 1;

export function serializeProject(state) {
  return JSON.stringify(
    {
      version: PROJECT_VERSION,
      app: "KAPEI Imposer PRO",
      savedAt: new Date().toISOString(),
      project: state,
    },
    null,
    2
  );
}

export function deserializeProject(jsonText) {
  const data = JSON.parse(jsonText);
  if (!data || data.app !== "KAPEI Imposer PRO") {
    throw new Error("Archivo no válido: no es un proyecto KAPEI.");
  }
  if (data.version !== PROJECT_VERSION) {
    // Accept any version 1.x; future migrations could go here.
    if (Math.floor(data.version) !== 1) {
      throw new Error("Versión de proyecto no soportada.");
    }
  }
  return data.project;
}

export function downloadProject(state, name = "kapei-project.json") {
  const blob = new Blob([serializeProject(state)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name.endsWith(".json") ? name : `${name}.json`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
